// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"04a98f17","160":"6cd5efdb","208":"43904f57","293":"aeeba2c8","516":"173acf83","519":"a36d34f2","906":"bd8c0f12","917":"7fdcc9bb","946":"93cc48a9"}[chunkId] + ".chunk.js";
};